class Sanction {

    constructor(
        id,
        name,
        number_player,
        team,
        category,
        causal,
        sanction
    ) {
        this.id = id || ''
        this.name = name || ''
        this.number_player = number_player || ''
        this.team = team || ''
        this.category = category || ''
        this.causal = causal || ''
        this.sanction = sanction || ''
    }

    static parse(responseData) {
        if(!responseData) return new Sanction()
        let d = responseData
        
        return new Sanction(
            d.id,
            d.name,
            d.number_player,
            d.team,
            d.category,
            d.causal,
            d.sanction
        )

    }

}

export default Sanction



// WEBPACK FOOTER //
// ./src/models/sanction.js